module.exports = __webpack_public_path__ + "img/home-05-panoramic-layer-03-high.cdbbf282.png";